<template>
  <div>
    <el-card class="filter-card">
      <div class="filter-form">
        <div class="filter-form-left">
          <el-input
            v-model="queryParams.username"
            placeholder="用户名"
            clearable
            style="width: 200px; margin-right: 10px;"
          />
          <el-input
            v-model="queryParams.email"
            placeholder="邮箱"
            clearable
            style="width: 200px; margin-right: 10px;"
          />
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>
        <el-button type="primary" @click="openAddDialog">新增</el-button>
      </div>
    </el-card>

    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="users"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="username" label="用户名" width="120" />
        <el-table-column prop="full_name" label="姓名" width="120" />
        <el-table-column prop="email" label="邮箱" width="180" />
        <el-table-column prop="is_active" label="激活状态" width="90">
          <template #default="{ row }">
            <el-tag :type="row.is_active ? 'success' : 'danger'" size="small">
              {{ row.is_active ? '激活' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="is_superuser" label="超级用户" width="90">
          <template #default="{ row }">
            <el-tag :type="row.is_superuser ? 'warning' : 'info'" size="small">
              {{ row.is_superuser ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="login_count" label="登录次数" width="100" />
        <el-table-column prop="last_login_at" label="最后登录" width="180" />
        <el-table-column prop="created_at" label="创建时间" width="180" />
        <el-table-column prop="updated_at" label="更新时间" width="180" />
        <el-table-column label="操作" width="80" fixed="right">
          <template #default="{ row }">
            <el-button size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button size="small" style="color: #f56c6c" @click="handleDelete(row)" v-if="false">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增用户弹窗 -->
    <el-dialog v-model="addDialogVisible" title="新增用户" width="600px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="姓名" prop="full_name">
          <el-input v-model="form.full_name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" show-password />
        </el-form-item>
        <el-form-item label="激活状态" prop="is_active">
          <div style="display: flex; align-items: center;">
            <el-switch v-model="form.is_active" />
            <span style="margin-left: 8px;">{{ form.is_active ? '激活' : '禁用' }}</span>
          </div>
        </el-form-item>
        <el-form-item label="超级用户" prop="is_superuser">
          <div style="display: flex; align-items: center;">
            <el-switch v-model="form.is_superuser" />
            <span style="margin-left: 8px;">{{ form.is_superuser ? '是' : '否' }}</span>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAdd">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 编辑用户弹窗 -->
    <el-dialog v-model="editDialogVisible" title="编辑用户" width="600px">
      <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="editForm.username" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="姓名" prop="full_name">
          <el-input v-model="editForm.full_name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editForm.email" placeholder="请输入邮箱" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="editForm.password" type="password" placeholder="请输入新密码（留空表示不修改）" show-password />
        </el-form-item>
        <el-form-item label="激活状态" prop="is_active">
          <div style="display: flex; align-items: center;">
            <el-switch v-model="editForm.is_active" />
            <span style="margin-left: 8px;">{{ editForm.is_active ? '激活' : '禁用' }}</span>
          </div>
        </el-form-item>
        <el-form-item label="超级用户" prop="is_superuser">
          <div style="display: flex; align-items: center;">
            <el-switch v-model="editForm.is_superuser" />
            <span style="margin-left: 8px;">{{ editForm.is_superuser ? '是' : '否' }}</span>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitEdit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { getUsers, createUser, getUser, updateUser } from '@/services/user'
import { ElMessage } from 'element-plus'
import { extractErrorMessage } from '@/utils/errorHandler'

export default {
  name: 'AccountMgmt',
  setup() {
    const loading = ref(false)
    const users = ref([])
    const total = ref(0)
    const currentPage = ref(1)
    const pageSize = ref(20)
    const queryParams = ref({
      username: '',
      email: ''
    })

    const addDialogVisible = ref(false)
    const formRef = ref(null)
    const form = ref({
      username: '',
      full_name: '',
      email: '',
      password: '',
      is_active: true,
      is_superuser: false
    })
    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
      ],
      email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, message: '密码长度至少为6位', trigger: 'blur' }
      ]
    }

    const editDialogVisible = ref(false)
    const editFormRef = ref(null)
    const currentEditId = ref(null)
    const editForm = ref({
      username: '',
      full_name: '',
      email: '',
      password: '',
      is_active: true,
      is_superuser: false
    })
    const editRules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
      ],
      email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
      ],
      password: [
        { min: 6, message: '密码长度至少为6位', trigger: 'blur' }
      ]
    }

    const fetchUsers = async () => {
      loading.value = true
      try {
        const params = {
          page: currentPage.value,
          size: pageSize.value,
          ...queryParams.value
        }
        // 移除空字符串参数
        Object.keys(params).forEach(key => {
          if (params[key] === '') {
            delete params[key]
          }
        })
        
        const data = await getUsers(params)
        // 假设返回的数据结构为 { items: [], total: 0 }
        users.value = data.users || data.items || []
        total.value = data.total || 0
      } catch (error) {
        console.error('获取用户列表失败:', error)
        ElMessage.error(extractErrorMessage(error, '获取用户列表失败'))
      } finally {
        loading.value = false
      }
    }

    const handleSizeChange = (size) => {
      pageSize.value = size
      currentPage.value = 1
      fetchUsers()
    }

    const handleCurrentChange = (page) => {
      currentPage.value = page
      fetchUsers()
    }

    const handleSearch = () => {
      currentPage.value = 1
      fetchUsers()
    }

    const resetSearch = () => {
      queryParams.value = {
        username: '',
        email: ''
      }
      currentPage.value = 1
      fetchUsers()
    }

    const openAddDialog = () => {
      addDialogVisible.value = true
      // 重置表单
      form.value = {
        username: '',
        full_name: '',
        email: '',
        password: '',
        is_active: true,
        is_superuser: false
      }
      if (formRef.value) {
        formRef.value.clearValidate()
      }
    }

    const submitAdd = async () => {
      if (!formRef.value) return
      try {
        await formRef.value.validate()
      } catch (error) {
        // 验证失败，不需要显示错误，因为Element UI已经在表单字段上显示了错误信息
        return
      }
      try {
        await createUser(form.value)
        ElMessage.success('用户创建成功')
        addDialogVisible.value = false
        fetchUsers() // 刷新列表
      } catch (error) {
        console.error('创建用户失败:', error)
        ElMessage.error(extractErrorMessage(error))
      }
    }

    const openEditDialog = async (row) => {
      editDialogVisible.value = true
      currentEditId.value = row.id
      
      // 先用列表中的数据填充表单（兼容列表接口没有返回全部数据的情况）
      editForm.value = {
        username: row.username || '',
        full_name: row.full_name || '',
        email: row.email || '',
        password: '',
        is_active: row.is_active !== undefined ? row.is_active : true,
        is_superuser: row.is_superuser !== undefined ? row.is_superuser : false
      }
      
      // 清除表单验证状态
      if (editFormRef.value) {
        editFormRef.value.clearValidate()
      }
      
      // 然后尝试获取完整用户详情
      try {
        const userData = await getUser(row.id)
        // 用接口返回的完整数据更新表单
        editForm.value = {
          username: userData.username || '',
          full_name: userData.full_name || '',
          email: userData.email || '',
          password: '',
          is_active: userData.is_active !== undefined ? userData.is_active : true,
          is_superuser: userData.is_superuser !== undefined ? userData.is_superuser : false
        }
      } catch (error) {
        console.error('获取用户详情失败:', error)
        // 显示警告，提示用户详情获取失败，显示列表数据
        ElMessage.warning('获取用户详情失败，显示部分信息')
      }
    }

    const submitEdit = async () => {
      if (!editFormRef.value) return
      try {
        await editFormRef.value.validate()
      } catch (error) {
        // 验证失败，不需要显示错误，因为Element UI已经在表单字段上显示了错误信息
        return
      }
      try {
        const updateData = { ...editForm.value }
        // 如果密码为空，则不更新密码字段
        if (!updateData.password) {
          delete updateData.password
        }
        await updateUser(currentEditId.value, updateData)
        ElMessage.success('用户更新成功')
        editDialogVisible.value = false
        fetchUsers() // 刷新列表
      } catch (error) {
        console.error('更新用户失败:', error)
        ElMessage.error(extractErrorMessage(error))
      }
    }

    const handleEdit = (row) => {
      openEditDialog(row)
    }

    const handleDelete = (row) => {
      console.log('删除用户:', row)
      // 实际删除逻辑待实现
    }

    onMounted(() => {
      fetchUsers()
    })

    return {
      loading,
      users,
      total,
      currentPage,
      pageSize,
      queryParams,
      addDialogVisible,
      form,
      rules,
      formRef,
      editDialogVisible,
      editForm,
      editRules,
      editFormRef,
      handleSizeChange,
      handleCurrentChange,
      handleSearch,
      resetSearch,
      openAddDialog,
      submitAdd,
      openEditDialog,
      submitEdit,
      handleEdit,
      handleDelete
    }
  }
}
</script>

<style scoped>
.header {
  margin-bottom: 10px;
}
.header h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  color: #303133;
}
.header p {
  margin: 0;
  color: #909399;
  font-size: 14px;
}
.filter-card {
  margin-bottom: 10px;
}
.filter-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filter-form-left {
  display: flex;
  align-items: center;
}
.table-card {
  margin-bottom: 10px;
}
.content-preview {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}
.pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
